import { memo } from 'react';
import { Link } from 'react-router-dom';
import {
  Chrome, Database, Server, CreditCard, Landmark, Scale, Globe, Heart,
  GraduationCap, Bot, Sparkles, Crown, HandHeart, Code2, Cloud,
  CircleDollarSign, Calculator,
} from 'lucide-react';

// Everyone and everything it took to get here — rolling end to end, bathed in gold.
const JOURNEY = [
  { name: 'Amie Menz', tag: 'FOUNDER', icon: Crown },
  { name: 'ManaMetaMaori', tag: 'FOUNDER', icon: Crown },
  { name: 'Stripe', icon: CreditCard },
  { name: 'Google', icon: Chrome },
  { name: 'Supabase', icon: Database },
  { name: 'PostgreSQL', icon: Database },
  { name: 'Claude Code', icon: Bot },
  { name: 'Gemini', icon: Sparkles },
  { name: 'Meta', icon: Globe },
  { name: 'Replit', icon: Code2 },
  { name: 'Next.js', icon: Code2 },
  { name: 'SiteGround', icon: Server },
  { name: 'Hostinger', icon: Cloud },
  { name: 'ING', icon: Landmark },
  { name: 'Kiwibank', icon: Landmark },
  { name: 'Innes & Dean', tag: 'LEGAL', icon: Scale },
  { name: 'TAFE Queensland', icon: GraduationCap },
  { name: 'Queensland Government', icon: Landmark },
  { name: 'Te Pāti Māori NZ', icon: HandHeart },
  { name: 'Beyond Blue', icon: Heart },
  { name: 'Best Care Whakapai Hauora PN', icon: HandHeart },
  { name: 'Your investment here', tag: 'INVESTOR', icon: CircleDollarSign, placeholder: true, to: '/investors' },
  { name: 'Your cosmetic brand here', tag: 'PARTNER', icon: Sparkles, placeholder: true, to: '/investors' },
  { name: 'Your accountant here', tag: 'WANTED', icon: Calculator, placeholder: true, to: '/investors' },
];

function JourneyBadge({ item }) {
  const Icon = item.icon;
  const inner = (
    <span className={`flex items-center gap-2 px-5 py-2.5 rounded-full border whitespace-nowrap mx-3 ${
      item.placeholder
        ? 'border-dashed border-primary/50 text-primary'
        : 'border-border/40 text-foreground/80'
    }`}>
      <Icon className="h-4 w-4 text-primary shrink-0" />
      <span className="text-sm font-medium">{item.name}</span>
      {item.tag && (
        <span className="text-[9px] uppercase tracking-[0.2em] text-primary border border-primary/40 rounded-full px-2 py-0.5">
          {item.tag}
        </span>
      )}
    </span>
  );
  return item.to ? <Link to={item.to}>{inner}</Link> : inner;
}

// Bottom trust banner: the journey ticker + the seat we're keeping warm.
// Sitemap/socials/legal live in the shared <Footer /> rendered right below —
// duplicating them here gave the landing page a double footer.
// Memoized — the landing page re-renders on scroll (parallax) and this whole
// strip must not re-paint with it.
function TrustStrip() {
  return (
    <div className="border-t border-border/30 bg-background/95">
      {/* Ticker tape — the journey, end to end, on a loop */}
      <div className="py-5 border-b border-border/20 overflow-hidden relative" aria-label="With thanks to everyone who got us here">
        <div className="onda-ticker flex w-max">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
              {JOURNEY.map((item) => (
                <JourneyBadge key={`${copy}-${item.name}`} item={item} />
              ))}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-background to-transparent" />
      </div>

      <div className="container mx-auto max-w-7xl px-6 py-6 flex justify-center">
        <Link to="/investors"
          className="px-4 py-2 rounded-full border border-dashed border-primary/50 text-xs text-primary hover:bg-primary/10 transition-colors">
          Your logo here — investors &amp; partners →
        </Link>
      </div>
    </div>
  );
}

export default memo(TrustStrip);
